import { sprintf } from 'sprintf-js';

import type { ApiAddress } from 'api/types/ApiAddress';
import type { ApiRemoteOptions } from 'api/types/ApiRemoteOptions';
import { getCityStateString } from 'utils/address/getCityStateString';
import { getCountryName, getUsStateName } from 'utils/internationalization';

type Args = {
  listingType: 'JOB' | 'INTERNSHIP' | 'VOLOP' | 'EVENT';
  remoteOptions: ApiRemoteOptions;
  address: ApiAddress;
};

export function getListingViewHeaderLocationSentence({
  listingType,
  remoteOptions,
  address,
}: Args) {
  if (listingType === 'EVENT') {
    if (remoteOptions.remoteZone) {
      return getText('Can attend remotely');
    }

    return getCityStateString(address);
  }

  if (remoteOptions.remoteZone === 'WORLD') {
    if (listingType === 'VOLOP') {
      return getText('Volunteer can be anywhere in the world');
    }

    return getText('Work can be performed from anywhere in the world');
  }

  if (remoteOptions.remoteZone === 'COUNTRY') {
    if (listingType === 'VOLOP') {
      return sprintf(getText('Volunteer must be in %(location)s'), {
        location: getCountryName(remoteOptions.remoteCountry || ''),
      });
    }

    return sprintf(
      getText('Work can be performed from anywhere in %(location)s'),
      {
        location: getCountryName(remoteOptions.remoteCountry || ''),
      },
    );
  }

  if (remoteOptions.remoteZone === 'STATE') {
    if (listingType === 'VOLOP') {
      return sprintf(getText('Volunteer must be in %(state)s, %(country)s'), {
        state: getUsStateName(remoteOptions.remoteState || ''),
        country: remoteOptions.remoteCountry,
      });
    }

    return sprintf(
      getText('Work must be performed in %(state)s, %(country)s'),
      {
        state: getUsStateName(remoteOptions.remoteState || ''),
        country: remoteOptions.remoteCountry,
      },
    );
  }

  if (
    remoteOptions.locationType === 'ONSITE' ||
    remoteOptions.remoteZone === 'CITY'
  ) {
    if (listingType === 'VOLOP') {
      return sprintf(getText('Volunteer must be in or near %(location)s'), {
        location: getCityStateString(address),
      });
    }

    return sprintf(getText('Work must be performed in or near %(location)s'), {
      location: getCityStateString(address),
    });
  }
}
